import MainHeader from '@/components/MainHeader';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import { BreadcrumbSchema } from '@/components/SchemaOrg';

const PrivacyPolicy = () => {
  return (
    <>
      <SEOHead
        title="Privacy Policy | Materialidtf.it"
        description="Informativa sulla privacy di Materialidtf.it. Scopri come trattiamo i tuoi dati personali in conformità al GDPR."
        canonical="/privacy-policy"
        noindex={false}
      />
      <BreadcrumbSchema
        items={[
          { name: 'Home', url: '/' },
          { name: 'Privacy Policy', url: '/privacy-policy' }
        ]}
      />

      <MainHeader />
      <Navigation />

      <main className="min-h-screen bg-background py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold text-foreground mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-sm text-muted-foreground">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Titolare del Trattamento</h2>
              <p>
                Il titolare del trattamento dei dati personali è Materialidtf.it, con sede in Italia.
                Per qualsiasi informazione relativa al trattamento dei dati personali, è possibile contattarci all'indirizzo email: privacy@materialidtf.it
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Tipologie di Dati Raccolti</h2>
              <p>Fra i Dati Personali raccolti da questo sito, in modo autonomo o tramite terze parti, ci sono:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Dati di navigazione (indirizzo IP, browser, sistema operativo)</li>
                <li>Dati forniti volontariamente dall'utente (nome, email, telefono, indirizzo)</li>
                <li>Dati di acquisto e fatturazione</li>
                <li>Cookie e tecnologie di tracciamento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Finalità del Trattamento</h2>
              <p>I dati personali sono raccolti per le seguenti finalità:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Evasione degli ordini e gestione del rapporto contrattuale</li>
                <li>Assistenza clienti e supporto tecnico</li>
                <li>Adempimenti fiscali e contabili</li>
                <li>Invio di comunicazioni commerciali (previo consenso)</li>
                <li>Analisi statistiche e miglioramento dei servizi</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Base Giuridica del Trattamento</h2>
              <p>Il trattamento dei dati personali si basa su:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Esecuzione di un contratto di cui l'interessato è parte</li>
                <li>Adempimento di obblighi legali</li>
                <li>Consenso dell'interessato per finalità di marketing</li>
                <li>Legittimo interesse del titolare</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Conservazione dei Dati</h2>
              <p>
                I dati personali sono conservati per il tempo strettamente necessario a conseguire le finalità per cui sono stati raccolti e comunque per un periodo non superiore a quanto previsto dalla normativa vigente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Diritti dell'Interessato</h2>
              <p>L'utente ha il diritto di:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Accedere ai propri dati personali</li>
                <li>Richiedere la rettifica o la cancellazione dei dati</li>
                <li>Opporsi al trattamento</li>
                <li>Richiedere la portabilità dei dati</li>
                <li>Revocare il consenso in qualsiasi momento</li>
                <li>Proporre reclamo all'autorità di controllo (Garante Privacy)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Sicurezza dei Dati</h2>
              <p>
                Adottiamo misure di sicurezza tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, distruzione o divulgazione.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">8. Trasferimento dei Dati</h2>
              <p>
                I dati personali possono essere trasferiti a destinatari situati in paesi al di fuori dell'Unione Europea, nel rispetto delle garanzie previste dal GDPR.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">9. Contatti</h2>
              <p>
                Per esercitare i propri diritti o per qualsiasi domanda relativa alla presente Privacy Policy, è possibile contattarci a:
              </p>
              <ul className="list-none mt-4 space-y-2">
                <li><strong>Email:</strong> privacy@materialidtf.it</li>
                <li><strong>Telefono:</strong> +39 375 7190556</li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
